<template>
    <div class="quickMain">
        <p class="currentChe">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>结算</span></p>
        <div class="quick-box" style="margin-top: -10px;">
            <div class="quick-province">
               <div style=" display: flex;justify-content: space-between;align-items: center;margin-bottom: 20px;">
                    <p class="pTitle">收货地址</p>
                   
                   <el-button round @click="HandleAddress(1)">选择/添加收货地址</el-button>
               </div>
                <div>
                    <p>{{ orderAdd.province_name }}  {{ orderAdd.city_name }}  {{ orderAdd.county_name }}</p>
                    <p>{{ orderAdd.address }}</p>
                    <p>{{ orderAdd.contact }}  {{ orderAdd.phone }}</p>
                </div>
            </div>
            <div style="padding: 20px 20px;background-color: #ffffff;margin-bottom: 20px;display: flex;justify-content: space-between;">
                <span class="pTitle">是否开发票</span>
                <el-switch
                    v-model="contains_invoice"
                    active-color="#10aeff"
                    active-value="1"
                    inactive-color="#999999"
                    inactive-value="0">
                </el-switch>

            </div>
            <div class="quick-province" v-show="contains_invoice == 1">
                <p class="pTitle">发票信息</p>
                <div class="fapiao">
                    <span class="fapiaoSpan" :class="fapiaoActive == item.dict_code? 'fapiaoActive':''" 
                        @click="handleInvoicedict(item)" v-for="item,index in dictDate" :key="index">
                        {{ item.dict_label}}
                        <img v-show="fapiaoActive == item.dict_code" src="@/assets/rightBottom.png" alt="">
                        <div v-show="fapiaoActive == item.dict_code" class="title-info"></div>
                    </span>
                
                    <el-button style="padding: 8px 15px;"  @click="AddInvoice">
                        +添加发票信息
                    </el-button>
                    <div class="info-div">
                        <div class="invoice-info">
                           
                            <div style="line-height: 35px;font-size: 13px;" v-for="(item,index) in invoiceInfoList" :key="item.id" class="invoiceItem" 
                               :class="item.is_default == 1?'isDefauleClass':''"  >
                               <div v-if="fapiaoActive == '156' || fapiaoActive == '157'" style=" display: flex;justify-content: space-between;align-items: center;">
                                    <div class="invoiceType" v-show="item.invoice_type == 1"> 
                                        <span style="border: none">企业</span>
                                        <span style="border: none">发票抬头： {{ item.name }}</span>
                                    </div>
                                
                                    <div class="operate"  v-show="item.invoice_type == 1">
                                        

                                        <p v-show="item.is_default == 0" style="padding: 0;" @click="invoiceSetdefault(item.id)">使用</p>
                                        <p @click="HandleInvoiceUpdate(item)">修改</p>
                                        <p @click="invoiceDelete(item.id)">删除</p>
                                    </div>  
                                    <img src="@/assets/success.png" alt="" v-show="item.is_default == 1 && item.invoice_type == 1">
                               </div>

                               <div v-else style=" display: flex;justify-content: space-between;align-items: center;">
                                    <div class="invoiceType"> 
                                        <span style="border: none">{{ item.invoice_type == 0 ? '个人': item.invoice_type == 1 ? '企业':'' }}</span>
                                        <span style="border: none">发票抬头： {{ item.name }}</span>
                                    </div>
                                
                                    <div class="operate">
                                        

                                        <p v-show="item.is_default == 0" style="padding: 0;" @click="invoiceSetdefault(item.id)">使用</p>
                                        <p @click="HandleInvoiceUpdate(item)">修改</p>
                                        <p @click="invoiceDelete(item.id)">删除</p>
                                    </div>  
                                    <img src="@/assets/success.png" alt="" v-show="item.is_default == 1">
                               </div>
                                    
                            </div>
                           
                            <!-- <div v-show="invoiceInfoList.length > 4"  style="text-align: right;color: #10aeff;font-size: 14px;cursor: pointer;">
                                <span>
                                    更多
                                </span>
                            </div> -->
                        </div>
                        
                    </div>
                
                </div>
                <el-dialog :title="title" :visible.sync="fapiaoUploadOpen" width="55%" append-to-body>
                    <div style="width: 70%;margin: auto;">
                        <div style="display: flex;justify-content: flex-start;align-items: center;"> 
                            <div class="tipsClass" ></div>
                            <p style="color: tomato;line-height: 35px;">请认真核对以下信息 (输入框内容可编辑) ，确认无误请点击“保存”如有错误，不可重开。有效增值税专用发票开票资格仅有一个!</p>
                        </div>
                        <el-form style="margin-top: 30px;" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
                            <el-form-item label="选择发票类型:" prop="invoice_type">

                                
                                <span class="fapiaoSpan" :class="ruleForm.invoice_type == 1? 'fapiaoActive':''" 
                                    @click="ruleForm.invoice_type = 1">
                                    企业
                                    <img v-show="ruleForm.invoice_type == 1" src="@/assets/rightBottom.png" alt="">
                                </span>
                                <span class="fapiaoSpan" :class="ruleForm.invoice_type == 0? 'fapiaoActive':''" @click="ruleForm.invoice_type = 0"
                                    v-show="fapiaoActive != '156' && fapiaoActive != '157' ">
                                    个人
                                    <img v-show="ruleForm.invoice_type == 0" src="@/assets/rightBottom.png" alt="">
                                </span>
                            </el-form-item>
                            <el-form-item label="企业名称:" prop="company">
                                <el-input v-model="ruleForm.company" placeholder="请填写企业名称"></el-input>
                            </el-form-item>
                            <el-form-item label="企业邮箱:" prop="email">
                                <el-input v-model="ruleForm.email" placeholder="请填写企业邮箱"></el-input>
                            
                            </el-form-item>
                        
                            <!-- <el-form-item label="发票类型:" prop="type">
                                <el-checkbox-group v-model="ruleForm.type">
                                    <el-checkbox label="增值税专用发票" name="type"></el-checkbox>
                                    <el-checkbox label="电子普通发票" name="type"></el-checkbox>
                                    <el-checkbox label="普通发票" name="type"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item> -->
                            <el-form-item label="发票抬头:" >
                                {{ ruleForm.company }}
                            </el-form-item>
                            <el-form-item label="纳税人识别号:" prop="identification" v-show="ruleForm.invoice_type == 1">
                                <el-input v-model="ruleForm.identification" placeholder="请填写纳税人识别号"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                                <el-button @click="resetForm()">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                   
                </el-dialog>
                <div style="margin-top: 20px;">
                    <div style=" display: flex;justify-content: space-between;align-items: center;margin-bottom: 20px;">
                            <p class="pTitle">收票地址</p>
                        
                        <el-button round @click="HandleAddress(2)">选择/添加收票地址</el-button>
                    </div>
                    <div>
                        <p>{{ orderInvoice.province_name }}  {{ orderInvoice.city_name }}  {{ orderInvoice.county_name }}</p>
                        <p>{{ orderInvoice.address }}</p>
                        <p>{{ orderInvoice.contact }}  {{ orderInvoice.phone }}</p>
                    </div>
                </div>
                
            </div>
            
            <div class="quick-province">
                <p class="pTitle">支付方式</p>
                <div style="margin-top: 20px;">
                
                  
                    <span class="fapiaoSpan" :class="cateActive == item.dict_value? 'fapiaoActive':''" 
                        @click="cateActive = item.dict_value" v-for="item,index in cateDate" :key="index">
                        {{ item.dict_label}}
                        <img v-show="cateActive == item.dict_value" src="@/assets/rightBottom.png" alt="">
                    </span>
                </div>
            </div>
            <div style="background-color: #ffffff;padding: 20px 20px;">
                <p class="pTitle">商品清单</p>
                <div  v-for="item in orderAdd.order_items" :key="item.id">
                    <div class="checkoutQuick-box">
                        <div class="Item-left " v-show="orderAdd != ''" >
                            <div :style="'background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;width: 110px;height: 82px;'"></div>
                            <div class="left-font">
                                <p>{{item.product_name}}</p>
                                <p>
                                    <span>￥{{item.price}}</span>
                                    <span>已选中规格： {{item.atts_items_names }}</span>
                                </p>
                                <p class="jifen" v-if="item.use_profit_jifen_rate != 0">
                                    最多可抵扣{{ item.use_profit_jifen_rate }}% 金额
                                   
                                </p>
                            </div>
                            
                        </div>
                        <p class="amountP">
                            *{{ item.amount }}
                        </p>
                    </div>
                
                </div>
                <div class="checkedJif">
                    <el-checkbox v-model="checked" @change="IfUseProfitJifen()">使用积分</el-checkbox>
                    <p>积分余额： {{ userInfo.ProfitJifen }}</p>
                </div>
                <div class="checkedJif" v-show="checked" style="margin-top: 2px;">
                    <div></div>
                    <p>可使用{{ ProfitJifen }}积分抵扣￥{{ (ProfitJifen/100).toFixed(2) }}</p>
                </div>
                
            </div>
            <div class="quick-province" style="margin-top: 20px;">
                <p class="pTitle">采购备注信息</p>
                <el-form style="margin-top: 20px" :model="ruleNotes" :rules="rulesNotes" ref="ruleNotes" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="发货方式:" prop="delivery">
                        <span class="fapiaoSpan" :class="ruleNotes.delivery == item.dict_value? 'fapiaoActive':''" 
                            @click="ruleNotes.delivery = item.dict_value" v-for="item,index in deliveryDate" :key="index">
                            {{ item.dict_label}}
                            <img v-show="ruleNotes.delivery == item.dict_value" src="@/assets/rightBottom.png" alt="">
                        </span>
                        
                        <p style="margin-top: 5px;font-size: 12px;">提示：危险品、部分化学品、易碎异行商品，应运输要求，可能会单独运输分开发货</p>
                    </el-form-item>
                    <el-form-item label="期望交货日期:" prop="expected">
                        <span class="fapiaoSpan" :class="ruleNotes.expected == item.dict_value? 'fapiaoActive':''" 
                            @click="ruleNotes.expected = item.dict_value" v-for="item,index in expectedDate" :key="index">
                            {{ item.dict_label}}
                            <img v-show="ruleNotes.expected == item.dict_value" src="@/assets/rightBottom.png" alt="">
                        </span>
                        
                    </el-form-item>
                    <!-- <el-form-item label="订单号:">
                        <el-input placeholder="请填写贵公司标准采购订单编号" v-model="ruleNotes.code"></el-input>
                    </el-form-item> -->
                    <el-form-item label="备注:">
                        <el-input placeholder="建议和客服事先确认"  type="textarea" :rows="4" v-model="ruleNotes.remarks" style="width: 80%;"></el-input>
                    </el-form-item>
                    <el-form-item label="客户合同附件:">
                        <div class="list-card-img">
                            <img width="200px" height="150px" v-for="item in ruleNotes.file_items" :key="item.FileUrl" :src="item.FileUrl" alt="">
                            <el-upload
                                ref="upload"
                                :limit="9"
                                :http-request="handleTransform"
                                action="https://qiliangong.oss-cn-shenzhen.aliyuncs.com"
                            >
                                <i class="el-icon-plus borderI" ></i>
                            </el-upload>
                        </div>
                        <p style="font-size: 12px;margin-top: 10px;">
                            (非必填，最多可上传9个)
                        </p>
                    </el-form-item>
                </el-form>
            </div>
            <div class="quick-province">
                <div class="checkedJif" style="margin-top: 20px;font-weight: 700;font-size: 20px;display: flex;justify-content: flex-end;">
                    <p><span style="font-size: 14px;font-weight: 200;">实付：￥</span> {{ num }}</p>
                    <el-button type="primary" @click="getSettlement('ruleNotes')" >提交订单</el-button>
                </div>
            </div>
        </div>
        <el-dialog
            title="扫码支付"
            :visible.sync="dialogFormEdit"
            customClass="messageDialog"
            >
            <div slot="footer" class="dialog-footer">
            <div id="canvas">

            </div>
            </div>
        </el-dialog>        
       
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import axios from 'axios';
export default{
    data(){
        var checkEmail = (rule, value, callback) => {
            const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            if (!value) {
            return callback(new Error('邮箱不能为空'))
            }
            setTimeout(() => {
            if (mailReg.test(value)) {
                callback()
            } else {
                callback(new Error('请输入正确的邮箱格式'))
            }
            }, 100)
        }
        return{
            title:'',
            InvoiceDictId: '',
            cateActive: 0,
            orderAdd: [],
            orderInvoice: [],
            invoiceInfoList: [],
            dictDate: [],
            deliveryDate: [],
            expectedDate: [],
            cateDate: [],
            checked: false,
            num: 0,
            userInfo: {},
            addressInfo: false,
            ProfitJifen: 0,
            dialogFormEdit: false,
            moneyNum: 0,
            order: '',
            fapiaoActive: '',
            cateActive:'',
            fapiaoUploadOpen: false,
            contains_invoice: 0,
            ruleForm: {
                company: '',
                email: '',
                id: '',
                invoice_type: '',
                identification: ''
            },
            rules: {
                company: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                email: [
                    { required: true, trigger: 'blur', validator: checkEmail }
                ],
               
                invoice_type: [
                    {  required: true, message: '请选择一个发票类型', trigger: 'change' }
                ],
               
               
            },
            ruleNotes: {
                file_items: [],
                remarks: '',
                code: '',
                expected: '',
                delivery: ''
            },
            rulesNotes: {
                expected: [
                    {required: true, message: '请选择期望交货日期', trigger: 'blur'}
                ],
                delivery: [
                    {required: true, message: '请选择发货方式', trigger: 'blur'}
                ]
            },
            invoiceId: '',
            payType: 'native',
            product_id: '',
            timer: null

        }
    },
    watch: {
       contains_invoice(newVal,oldval){
           
            sessionStorage.setItem('containsInvoice',newVal)

            // this.ruleNotes = JSON.parse(sessionStorage.getItem('ruleNotesItem'))
       },
       dialogFormEdit(newVal,oldVal){
            if(!newVal){
                clearInterval(this.timer);

                this.$router.replace({
                    path: "/myOrders",
                    query: {
                    vsstatus: 'notpay'
                    }
                });
            }
       }    
    },
    methods: {
        handleInvoicedict(item){
            this.fapiaoActive = item.dict_code
            this.InvoiceDictId = item.dict_value
        },
        AddInvoice(){
            this.title = '添加发票信息'
            this.fapiaoUploadOpen = true
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                let identification = ''
                if(this.ruleForm.invoice_type == 1){ //企业
                    identification = this.ruleForm.identification
                }else if(this.ruleForm.invoice_type == 0){ // 个人
                    identification = ''
                }
                if(this.title == '添加发票信息'){
                    
                    let data = {
                        name: this.ruleForm.company,
                        email: this.ruleForm.email,
                        identification: identification,
                        invoice_type: this.ruleForm.invoice_type
                    }

                    this.$store.dispatch('personal/invoiceAdd',data)
                        .then(res => {
                            if(res.ok){
                                this.$notify({
                                    title: '提示',
                                    message: '添加成功',
                                    type: 'success'
                                })

                                this.ruleForm = {
                                    company: '',
                                    email: '',
                                    id: '',
                                    invoice_type: '',
                                    identification: ''
                                }
                                this.fapiaoUploadOpen = false
                                this.invoiceListByUser()
                            }
                        })
                }else if(this.title == '修改发票信息'){
                    let data = {
                        name: this.ruleForm.company,
                        email: this.ruleForm.email,
                        identification: identification,
                        invoice_type: this.ruleForm.invoice_type,
                        id: this.ruleForm.id
                    }
                    this.$store.dispatch('personal/invoiceUpdate',data)
                        .then(res => {
                            if(res.ok){
                                this.$notify({
                                    title: '提示',
                                    message: '修改成功',
                                    type: 'success'
                                })

                                this.ruleForm = {
                                    company: '',
                                    email: '',
                                    id: '',
                                    invoice_type: '',
                                    identification: ''
                                }
                                this.fapiaoUploadOpen = false
                                this.invoiceListByUser()
                            }
                        })
                }
            } else {
                
            }
            });
        },
        resetForm() {
            this.fapiaoUploadOpen = false
        },
        HandleInvoiceUpdate(item){
            this.title = '修改发票信息'
            this.fapiaoUploadOpen = true
            this.ruleForm = {
                company: item.name,
                email: item.email,
                id : item.id,
                invoice_type: item.invoice_type,
                identification: item.identification
            }
           

        },
        invoiceSetdefault(id){
            let data = {
                id: id
            }
            this.$store.dispatch('personal/invoiceSetdefault',data)
            	.then(res => {
                    if(res.ok){
                        this.$notify({
                            title: '提示',
                            message: '使用成功',
                            type: 'success'
                        })
                        this.invoiceListByUser()
                    }
                })
        },
        invoiceDelete(id){
            this.$confirm('确定要删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    ids: id
                }
                this.$store.dispatch('personal/invoiceDelete',data)
                    .then(res => {
                        if (res.ok) {
                            this.$notify({
                                title: '提示',
                                message: '删除成功',
                                type: 'success'
                            })

                            this.invoiceListByUser()
                        }
                    })
            
            }).catch(() => {
                    
            });
        },
        IfUseProfitJifen(){
            this.moneyNum = 0
            let jifenPeice = 0
            // let jine = 0
            for (let index = 0; index < this.orderAdd.order_items.length; index++) {
                this.moneyNum = this.moneyNum+this.orderAdd.order_items[index].price * this.orderAdd.order_items[index].amount

                if(this.orderAdd.order_items[i].use_profit_jifen_rate != 0){
                    jifenPeice = jifenPeice + this.orderAdd.order_items[index].price * ( this.orderAdd.order_items[i].use_profit_jifen_rate / 100 ) * this.orderAdd.order_items[index].amount
                }
            }
            
            if(this.checked){
                // if(this.moneyNum <= 0.03){
                
               
                if((jifenPeice * 100).toFixed(2) >= this.userInfo.ProfitJifen){
                    this.ProfitJifen = this.userInfo.ProfitJifen
                    let pri = (this.userInfo.ProfitJifen / 100).toFixed(2)
                    this.num = (this.num - pri).toFixed(2)
                }else{
                    this.num = (this.num - jifenPeice).toFixed(2); 
                    this.ProfitJifen = (jifenPeice * 100).toFixed(2)
                }
                // }else{
                //     this.num = (this.num - '0.03').toFixed(2); 
                //     this.ProfitJifen = 3
                // }
            }else{
                this.num =  this.moneyNum.toFixed(2); 
            }
            
        },
        infoUser(){
            let data = {}
            this.$store.dispatch('personal/userInfo',data)
                .then(res => {
                    if(res.ok){
                        this.userInfo = res.data
                    }
                })
        },
     
        getSettlement(formName){
            if(!this.addressInfo){
                this.$alert('请选择收货地址','提示',{
                    confirmButtonText: '确定'
                })
            }else{
                if(this.contains_invoice == 1){
                    if(!this.orderInvoice){
                        this.$alert('请选择发票地址','提示',{
                            confirmButtonText: '确定'
                        })
                    }else{
                        this.$refs[formName].validate((valid) => {
                            if (valid) {
                                let invoiceAddressId = JSON.parse(sessionStorage.getItem('orderInvoice')) 

                                let fileUrlList = ''
                                if(this.ruleNotes.file_items.length != 0){
                                    fileUrlList = this.ruleNotes.file_items
                                    fileUrlList = JSON.stringify(fileUrlList)
                                }
                                
                                this.invoiceId = ''
                                if(this.fapiaoActive == '156' || this.fapiaoActive == '157'){
                                    
                                    this.invoiceInfoList.forEach(item => {
                                    
                                        if(item.is_default == 1 && item.invoice_type == 1){
                                            this.invoiceId = item.id
                                        }
                                    });
                                    
                                    
                                }else{
                                    this.invoiceInfoList.forEach(item => {
                                    
                                        if(item.is_default == 1){
                                            this.invoiceId = item.id
                                        }
                                    });
                                }
                
                                if(!this.invoiceId){
                                    this.$notify({
                                        title: '提示',
                                        message: '请选择发票信息',
                                        type: 'info'
                                    })
                                }else{
                                    // if(this.cateActive == 'offline'){
                                    //     this.payType = ''
                                    // }
                                    let data = {
                                        IfUseProfitJifen: this.checked,
                                        order_cate: "product",
                                        ids: this.product_id,
                                        order_no: this.order,
                                        pay_cate: this.cateActive,// 支付方式
                                        invoice_id: this.invoiceId,// 发票id
                                        invoice_address_id: invoiceAddressId.id,// 发票地址id
                                        order_invoice_type: parseInt(this.InvoiceDictId),// 发票类型id
                                        delivery: parseInt(this.ruleNotes.delivery),// 派送方式
                                        expected_deliverys: parseInt(this.ruleNotes.expected),//派送时间
                                        // order_cate: parseInt(this.cateActive),
                                        remarks: this.ruleNotes.remarks,// 备注
                                        order_remark_file_items: fileUrlList,// 文件
                                        pay_type: this.payType,
                                        contains_invoice: this.contains_invoice
                                    }
                                    console.log(data);                 
                                    this.$store.dispatch('personal/ordersSubmit',data)
                                        .then(res => {
                                            if(res.ok){
                                                if(res.data.pay_cate == '0'){//线下
                                                    this.$confirm('您已提交线下交易订单，点击确认获取支付信息', '提示', {
                                                        confirmButtonText: '确定',
                                                        cancelButtonText: '取消',
                                                        type: 'warning'
                                                    }).then(() => {
                                                        this.$router.replace({
                                                            path: "/myOrders",
                                                            query: {
                                                            vsstatus: 'notpay'
                                                            }
                                                        });
                                                    }).catch(() => {
                                                            
                                                    });
                                                    // this.$router.replace({
                                                    //     path: '/offline',
                                                    //     query: {
                                                    //         orderNo: res.data.ordre_no,
                                                    //         total_price: res.data.total_price,
                                                    //     }
                                                    // })
                                                    
                                                
                                                }else if(res.data.pay_cate == '1'){ //微信支付
                                                    document.getElementById( 'canvas' ).innerHTML =  '' ;
                                                    this.dialogFormEdit = true

                                                    var qrcode = new QRCode('canvas', {
                                                        text: res.data.code_url,
                                                        width: 150,
                                                        height: 150,
                                                        colorDark : '#000000',
                                                        colorLight : '#ffffff',
                                                        correctLevel : QRCode.CorrectLevel.H
                                                    });
                                                
                                                    this.timer = setInterval(() => {
                                                        this.getPaystatus(res.data.order_no)
                                                    }, 5000)
                                            
                                                }
                                            

                                                
                                            }
                                        })
                                }
                        
                            } else {
                                console.log('error submit!!');
                                return false;
                            }
                        });
                    }
                }else{
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            let invoiceAddressId = JSON.parse(sessionStorage.getItem('orderInvoice')) 

                            let fileUrlList = ''
                            if(this.ruleNotes.file_items.length != 0){
                                fileUrlList = this.ruleNotes.file_items
                                fileUrlList = JSON.stringify(fileUrlList)
                            }
                            
                            
            
                         
                                // if(this.cateActive == 'offline'){
                                //     this.payType = ''
                                // }
                                let data = {
                                    IfUseProfitJifen: this.checked,
                                    order_cate: "product",
                                    ids: this.product_id,
                                    order_no: this.order,
                                    pay_cate: this.cateActive,// 支付方式
                                    invoice_id: this.invoiceId,// 发票id
                                    invoice_address_id: invoiceAddressId.id,// 发票地址id
                                    order_invoice_type: parseInt(this.InvoiceDictId),// 发票类型id
                                    delivery: parseInt(this.ruleNotes.delivery),// 派送方式
                                    expected_deliverys: parseInt(this.ruleNotes.expected),//派送时间
                                    // order_cate: parseInt(this.cateActive),
                                    remarks: this.ruleNotes.remarks,// 备注
                                    order_remark_file_items: fileUrlList,// 文件
                                    pay_type: this.payType,
                                    contains_invoice: this.contains_invoice
                                }
                                console.log(data);                 
                                this.$store.dispatch('personal/ordersSubmit',data)
                                    .then(res => {
                                        if(res.ok){
                                            if(res.data.pay_cate == '0'){//线下
                                            
                                                this.$router.replace({
                                                    path: '/offline',
                                                    query: {
                                                        orderNo: res.data.ordre_no,
                                                        total_price: res.data.total_price,
                                                    }
                                                })
                                                
                                            
                                            }else if(res.data.pay_cate == '1'){
                                                document.getElementById( 'canvas' ).innerHTML =  '' ;
                                                this.dialogFormEdit = true

                                                var qrcode = new QRCode('canvas', {
                                                    text: res.data.code_url,
                                                    width: 150,
                                                    height: 150,
                                                    colorDark : '#000000',
                                                    colorLight : '#ffffff',
                                                    correctLevel : QRCode.CorrectLevel.H
                                                });
                                            
                                                this.timer = setInterval(() => {
                                                    this.getPaystatus(res.data.order_no)
                                                }, 5000)
                                        
                                            }
                                        

                                            
                                        }
                                    })
                           
                    
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                }
                        
            

               
               
            }
        },
        HandleAddress(val){
           
            if(val == 1){
                this.$router.push({
                    path: '/uconfigAddressInfo',
                    query:{
                        order:this.order
                    }
                })
            }else if(val == 2){
                // var stringify = JSON.stringify(this.ruleNotes)
                // sessionStorage.setItem('ruleNotesItem',stringify)

                this.$router.push({
                    path: '/uconfigInvoice',
                    query: {
                        order:this.order
                    }
                })
            }
        },
        getPaystatus(orderNo){
            setTimeout(()=>{
                let data = {
                    order_no: orderNo
                }
                this.$store.dispatch('personal/getPaystatus',data)
                    .then(res =>{
                        if(res.data.ispay == 1){
                            clearInterval(this.timer)
                            this.$notify({
                                title: '提示',
                                message: '支付成功',
                                type: 'success',
                            })

                            this.$router.push({
                                path: '/myOrders',
                                query: {
                                    vsstatus:'pay'
                                }
                            })

                        }
                    })
                
                
            }, 0)
         },
         getUUID(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
            })  
        },
        fileToBlob(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => {
                    const blob = new Blob([reader.result], { type: file.type });
                    resolve(blob);
                };

                reader.onerror = reject;

                reader.readAsArrayBuffer(file);
            });
        },
          // 上传文件
        handleTransform(file){
            
            console.log("上传的文件")
            console.log(file)
            let data = {}
            this.$store.dispatch('train/policy',data)
                .then(res => {
                    if(res.ok){

                        this.fileToBlob(file.file).then(blob => {
                           
                            console.log('Blob对象:', blob);
                           
                            console.log('ossPolicyX')
                            console.log(res)
                            var info = res.data
                            var key = info.dir + this.getUUID() + file.file.name.substring(file.file.name.lastIndexOf(".")) 
                            
                            console.log('key')
                            console.log(key)
                            let formData = new FormData()

                            formData.append('key', key)
                            formData.append('OSSAccessKeyId', info.accessId)
                            formData.append('policy', info.policy)
                            formData.append('signature', info.signature)
                            formData.append('success_action_status', '200')
                            formData.append('file', file.file)
                            
                            axios({
                                url: info.host,
                                contentType: false,
                                method: 'post',
                                data: formData,
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }).then(res => {
                                const { status } = res
                                if (status === 200) {
                                    var filename = file.file.name
                                    var pictureUrl = info.host + '/' + key;//获得到的url需要将其存数据库中
                                  
                                        this.ruleNotes.file_items.push({
                                            filename: filename,
                                            lanmu: 'booking',
                                            picurl: pictureUrl,
                                            FileName: filename,
                                            FileUrl: pictureUrl,

                                        })  
                                   

                                
                                } 
                            })
                     
                        });
						
						
					}
                })
           
        },
        invoiceListByUser(){
            let data = {}
            this.$store.dispatch('personal/invoiceListByUser',data)
                .then(res => {
                    if(res.ok){
                        let total = res.data.items.length
                        if(total != 0){
                            this.invoiceInfoList = res.data.items
                        }
                    }
                })
        },
        dictList1(){
            this.orderType('ordre_invoice_type') //订单发票信息
        },
        dictList2(){
            this.orderType('pay_cate') //支付方式
        },
        dictList3(){
            this.orderType('order_delivery') //订单发货日期
        },
        dictList4(){
            this.orderType('order_expected_delivery') //订单交货日期
        },
        orderType(val){
            let data = {
                dict_type: val,
                pigeSize: 9999,
                token: localStorage.getItem('token')
            }
            this.cateDate = []
            this.deliveryDate = []
            this.expectedDate =[]
            this.dictDate = []
            this.$store.dispatch('personal/dictList',data)
                .then(res => {
                    if(res.ok){
                        let total = res.data.items.length
                        
                        if(val == 'ordre_invoice_type'){
                           
                            if(total != 0){  
                                this.dictDate = res.data.items
                                this.fapiaoActive = this.dictDate[0].dict_code
                                this.InvoiceDictId = this.dictDate[0].dict_value
                            }
                           
                           
                        }else if(val == 'pay_cate'){
                            if(total != 0){ 
                                this.cateDate = res.data.items
                                this.cateActive = this.cateDate[0].dict_value
                            }
                                
                           
                        }else if(val == 'order_delivery'){
                            if(total != 0){
                                this.deliveryDate = res.data.items
                                this.ruleNotes.delivery = this.deliveryDate[0].dict_value
                            }
                            
                        }else if(val == 'order_expected_delivery'){
                            if(total != 0){ 
                                this.expectedDate = res.data.items
                                this.ruleNotes.expected = this.expectedDate[0].dict_value
                            }
                            
                        }
                      
                    }
                })
        },
        addressList(orderOn){
           
            this.$store.dispatch('personal/orderOn',orderOn)
                .then(res => {
                    if(res.ok){
                        this.orderAdd = res.data
                        this.orderAdd.order_items.forEach(item => {
                            this.num = (this.num+item.price*item.amount); 
                        });
                        this.num = this.num.toFixed(2)
                        if(this.orderAdd.province_name == '' || this.orderAdd.city_name == '' || this.orderAdd.county_name == '' || this.orderAdd.address == ''){
                            this.addressInfo = false
                        }else{
                            this.addressInfo = true
                        }

                        console.log(this.addressInfo);
                        
                    }   
                })

        },
        invoiceAddressList(){
            if(sessionStorage.getItem('orderInvoice')){
                this.orderInvoice = JSON.parse(sessionStorage.getItem('orderInvoice'))
            }else{
                let status ={
                    type: 1
                }
                this.$store.dispatch('personal/getDefAddress',status)
                    .then(res => {
                        if(res.ok){
                        
                            sessionStorage.setItem('orderInvoice',  JSON.stringify(res.data));
                            this.orderInvoice = res.data
                        

                        }
                    })
            }
        }
    },
    mounted(){
        if(sessionStorage.getItem('path') == '/uconfigInvoice'){
            this.contains_invoice = sessionStorage.getItem('containsInvoice')
        }
        this.num = 0
        let product_id = this.$route.query.ids
        this.product_id = parseInt(product_id)
        if(this.$route.query.order){
            this.order = this.$route.query.order

            let orderOn = {
                order_no: this.order,
                product_type: 'product'
            }
            this.addressList(orderOn)
        }else{
            this.product_id = this.$route.query.ids
            this.order = '888888'

            let orderOn = {
                order_no: this.order,
                ids:  this.product_id,
                product_type: 'product'
            }
            this.addressList(orderOn)
        }
        
        
        this.invoiceAddressList()

        this.invoiceListByUser()
        this.dictList1()
        this.dictList2()
        this.dictList3()
        this.dictList4()
        
        this.infoUser()
    }
}
</script>

<style scoped lang="scss">
.fapiaoSpan{
    cursor: pointer;
    padding: 8px 15px;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
    font-size: 14px;
    margin-right: 20px;
    position: relative;
    img{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 14px;
        height: 14px;
    }
}
.fapiaoActive{
    border: 1px solid #10aeff;
}
.quickMain{
    width: 1200px;
    margin: 10px auto;
    .currentChe{
        // margin-top: -45px;
        // position: relative;
        font-size: 17px;
        color: #333;
    }
    .quick-box{
        width: 1200px;min-height: 600px;
        margin: 20px auto;
        // background: #fff;
        padding: 20px 0px 150px 0px;
        position: relative;
        .quick-province{
            min-height: 80px;
            background-color: #fff;
           
            font-size: 18px;
            color: #666;
            padding: 20px 20px;
            border-bottom: 0.5px solid #f2f2f2;
            margin-bottom: 20px;
            
            p{
                line-height: 30px;
            }
          
            .fapiao{
                margin-top: 20px;
                color: #333;
                padding-bottom: 20px;
                border-bottom: 1px solid #f2f2f2;
                
                .fapiaoSpan{
                    cursor: pointer;
                    padding: 8px 15px;
                    border-radius: 5px;
                    border: 1px solid #e6e6e6;
                    font-size: 14px;
                    margin-right: 20px;
                    position: relative;
                    img{
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 14px;
                        height: 14px;
                    }
                    .title-info{
                            
                        width: 0;
                        height: 0;
                        position: absolute;
                        top: 48px;
                        left: 44px;
                        border-color: transparent transparent #f4f4f4;
                        border-style: solid;
                        border-width: 0 6px 9px;
                    }
                
                }
                .fapiaoActive{
                    border: 1px solid #10aeff;
                }
                .info-div{
                    margin-top: 10px;
                    // position: absolute;
                    // left: 0;
                    .invoice-info{
                        width: 820px;
                        background-color: #f4f4f4;
                        border-radius: 3px;
                        margin-top: 22px;
                        padding: 8px 20px;
                        box-sizing: border-box;
                        color: #333;
                        .invoiceItem{
                            cursor: pointer;
                           
                            span{
                                padding: 8px 15px;
                                font-size: 14px;
                                margin-right: 20px;
                            }
                            .invoiceType{
                                width: 85%;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                          
                            .operate{
                                display: flex;
                                justify-content: flex-start;
                                align-items: center;
                                p:hover{
                                    color: #10aeff;
                                }
                                p{
                                    margin-left: 10px;
                                }
                            }
                        }
                        .invoiceItem:hover{
                            // color: #10aeff;
                            border-bottom: 0.5px solid #ffffff;
                        }
                        .isDefauleClass{
                           
                            
                            img{
                                width: 30px;height: 30px;
                            }
                            
                        }
                       
                    }
                }
                
                
            
            }

            .deliveryClass{
                cursor: pointer;
                padding: 8px 15px;
                border-radius: 5px;
                border: 1px solid #e6e6e6;
                font-size: 14px;
                margin-right: 20px;
                position: relative;
                img{
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 14px;
                    height: 14px;
                }
            }
            .fapiaoActive{
                border: 1px solid #10aeff;
            }
            
        }
        .checkoutQuick-box{
            /* width: 1140px; */
            display: flex;
            padding: 20px 0px;
            justify-content: space-between;
            align-items: center;
            border-bottom: 0.5px solid #f2f2f2;
            
            .Item-left{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .left-font{
                    margin-left: 20px;
                    font-size: 19px;
                    p{
                        margin-bottom: 10px;
                    }
                    span{
                        color: #ff2f4f;
                        font-weight: 600;
                    }
                    p{
                        span:nth-child(2){
                            color: #999999;
                            font-size: 14px;
                            margin-left: 20px;
                        }
                    }
                    .jifen{
                        width: 100px;
                        margin-top: 10px;
                        padding: 5px 8px;
                        font-size: 14px;
                        color: #00a8a8;
                        background: rgba(0, 168, 168, 0.1);
                        border-radius: 50px;
                    }
                }
            }
            .amountP{
                padding-right: 20px;
                font-size: 20px;
                font-weight: 300;
            
            }

        }
        .checkedJif{
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 18px;
            ::v-deep .el-checkbox__label{
                font-size: 16px !important;
            }
            ::v-deep.el-checkbox__inner{
                width: 16px !important;
                height: 16px !important;
            }
            p{
                color: #4095e5;
                padding-right: 20px;
            }
        }


    }
    ::v-deep .messageDialog{
        width: 240px !important;
    }
    #canvas{
        text-align: center;
        margin: -30px 0 0 25px;
    }
}
::v-deep .el-dialog .el-dialog__header {
    line-height: 0px !important;
}
.pTitle{
    color: #000000;font-weight: 600;
}

.borderI{
    text-align: center;
    cursor: pointer;
    width: 200px;
    outline: 0;
    height: 150px;
    line-height: 150px;
    border-radius: 5px;
    border: 1px dashed #999999;
    font-size: 20px;
    color: #999999;
    margin-left: 5px;
}
.tipsClass{
    border: 1px solid #f2f2f2;
    margin-right: 30px;
    width: 160px;height: 90px;
    background-image: url('../../assets/tips.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.list-card-img {
    ::v-deep .el-upload-list__item{
        display: none !important;
    }
}
</style>